<div [ngClass]="{
    'bg-[var(--header-bg-home, #134F82)] p-4 border-b border-[#FFB95A] md:flex text-[#382100]': !hideHeaderDiv,
    'service-title': hideHeaderDiv,
    'banamex': hideHeaderDiv && isBanamex}">

    <div class="">
        <h2 class="text-xl md:text-3xl lg:headline-07 font-bold md:mx-2">Check-up Médico</h2>
    </div>
    <div class="pl-[15px] md:pl-0">
        <div class="mt-4 md:mt-0">

            <div class="md:mx-4">
                <p class="paragraph-default text-[#382100] ">
                    <strong>Expediente:</strong> {{ expediente || '#Procesando...' }}
                </p>
                <p class="paragraph-default text-[#2F1D00]">
                    <strong>Fecha:</strong> {{ fecha || 'Procesando...' }} | {{ hora || '--:--' }}
                </p>
            </div>

            <div class="md:m-4  flex">
                <span [class]="getStatusClass(clEstatus)">
                    <mat-icon class="icon-status">check_circle</mat-icon>
                    <p class="label-status">{{ getStatusDisplay(clEstatus) }}</p>
                </span>
            </div>


        </div>
    </div>
</div>

<div [ngClass]="{
    'bg-[] text-[#2F1D00] p-6 md:p-12 max-w-xl mx-auto': !hideHeaderDiv,
    'bg-white text-[#134F82] p-6 md:p-12 max-w-xl mx-auto': hideHeaderDiv
}">
    <!-- Título -->
    <h2 class="text-lg md:text-xl lg:headline-05 font-bold mb-4 md:mb-2">Generado exitosamente</h2>
    <p class="paragraph-default mb-6">
        Tu expediente ha sido generado. El formato de autorización para el servicio de Check-Up se envió a través de
        WhatsApp al número {{ getFormattedPhone() }}.
    </p>

    <!-- Botón de reenvío de WhatsApp -->
    <div class="whatsapp-resend-container" [ngClass]="{
        'default-theme': !hideHeaderDiv,
        'banamex-theme': hideHeaderDiv
    }">
        <div class="whatsapp-resend-content">
            <div class="whatsapp-info">
                <img src="assets/images/icons/whats.png" alt="WhatsApp" class="whatsapp-icon-large">
                <div class="whatsapp-text">
                    <p class="whatsapp-title">Reenviar por WhatsApp</p>
                    <p class="whatsapp-subtitle">Envía nuevamente el documento</p>
                </div>
            </div>
            <button class="whatsapp-resend-btn" (click)="resendWhatsApp()">
                <img src="assets/images/icons/whats.png" alt="WhatsApp" class="whatsapp-icon-small">
                Reenviar
            </button>
        </div>
    </div>



    <p class="paragraph-default mb-6">
        También puedes descargarlo aquí:
    </p>
     Sección de descarga de PDF 
    <div [ngClass]="{
        'bg-[#fff8f4] border border-[#B87400] rounded-xl p-4 mb-6 text-[#382100]': !hideHeaderDiv,
        'bg-[#D2E4FF29] border border-[#D9E7F3] rounded-xl p-4 mb-6 text-[#134F82]': hideHeaderDiv
    }">
        <div class="flex items-center justify-between">
           <!-- Miniatura del PDF -->
            <div class="pdf-thumbnail-small">
                <div class="pdf-page-small">
                    <div class="pdf-header-small"></div>
                    <div class="pdf-lines-small">
                        <div class="pdf-line-small"></div>
                        <div class="pdf-line-small short"></div>
                        <div class="pdf-line-small"></div>
                    </div>
                </div>
                 <!-- Información del archivo superpuesta -->
                <div class="pdf-info-overlay">
                    <p class="pdf-filename">checkup-{{ expediente.replace('#', '') }}.pdf</p>
                    <p class="pdf-size">245 KB</p>
                </div>
            </div>
            <button
                class="bg-[#0E365A] text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-[#0a2a47] transition cursor-pointer"
                (click)="downloadPDF()">
                <mat-icon>download</mat-icon>
                Descargar
            </button>
        </div>
    </div> 

    <div class="mt-8">
        <h3 class="text-lg md:text-xl lg:headline-05 font-bold mb-1">Detalles del servicio</h3>
        <p class="text-sm md:text-base mb-4">Encuentra todos los datos importantes sobre esta solicitud.</p>
    </div>

    <div [ngClass]="{
        'bg-[#fff8f4] border border-[#B87400] rounded-xl p-4 space-y-4 text-[#382100]': !hideHeaderDiv,
        'bg-[#D2E4FF29] border border-[#D9E7F3] rounded-xl p-4 space-y-4 text-[#134F82]': hideHeaderDiv
    }">

        <!-- Encabezado -->
        <div [ngClass]="{
      'flex justify-between items-center border-b border-[#B87400] pb-2 cursor-pointer': !hideHeaderDiv,
      'flex justify-between items-center border-b border-[#D9E7F3] pb-2 cursor-pointer': hideHeaderDiv
  }" (click)="toggleExpand()">
            <div class="flex items-center gap-2 font-semibold">
                <mat-icon [ngClass]="{
          'text-[#B87400]': !hideHeaderDiv,
          'text-[#134F82]': hideHeaderDiv
      }">medical_services</mat-icon>
                <h3 class="headline-03">Check-up</h3>
            </div>
            <mat-icon [ngClass]="{
        'text-[#B87400]': !hideHeaderDiv,
        'text-[#134F82]': hideHeaderDiv
    }">
                {{ expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
        </div>

        <!-- Sección desplegable -->
        <div *ngIf="expanded" class="space-y-4">

            <!-- Paciente -->
            <div [ngClass]="{
        'border-b border-[#845400] pb-2': !hideHeaderDiv,
        'border-b border-[#D9E7F3] pb-2': hideHeaderDiv
    }">
      <p class="headline-02 flex"><strong>Paciente</strong></p>
      <p>{{ patientName || 'No especificado' }}</p>
    </div>
    <div [ngClass]="{
        'border-b border-[#845400] pb-2': !hideHeaderDiv,
        'border-b border-[#D9E7F3] pb-2': hideHeaderDiv
    }">
      <p class="headline-02 flex"><strong>Laboratorio</strong></p>
      <p>{{ laboratory || '...' }}</p>
    </div>
    <div [ngClass]="{
        'border-b border-[#845400] pb-2': !hideHeaderDiv,
        'border-b border-[#D9E7F3] pb-2': hideHeaderDiv
    }">
      <p class="headline-02 flex"><strong>Dirección</strong></p>
      <p>{{ adress || '...' }}</p>
    </div>
    <div [ngClass]="{
        'border-b border-[#845400] pb-2': !hideHeaderDiv,
        'border-b border-[#D9E7F3] pb-2': hideHeaderDiv
    }">
      <p class="headline-02 flex"><strong>Estudio</strong></p>
      <p>{{ study || '...' }}</p>
    </div>

            <!-- Fecha y hora -->
            <div [ngClass]="{
        'flex justify-between text-sm border-b border-[#845400] pb-2': !hideHeaderDiv,
        'flex justify-between text-sm border-b border-[#D9E7F3] pb-2': hideHeaderDiv
    }">
                <div class="w-full">
                    <p class="headline-02 flex"><strong>Fecha de solicitud</strong></p>
                    <p>{{ fecha || 'Procesando...' }}</p>
                </div>
                <div class="w-full">
                    <p class="headline-02 flex"><strong>Hora de solicitud</strong></p>
                    <p>{{ hora || '--:--' }}</p>
                </div>
            </div>

            <!-- Precio -->
            <div>
                <p class="headline-02 flex"><strong>Precio</strong></p>
                <div class="flex items-center gap-2 text-sm">
                    <mat-icon fontIcon="workspace_premium" class="text-[#382100] text-base"></mat-icon>
                    <span class="headline-02">Cubierto por tu programa</span>
                </div>
            </div>

        </div>
    </div>

    <!-- Sección de cancelación/dudas -->
    <div class="cancel-support-section">
        <h4 class="headline-04">¿Quieres cancelar o tienes dudas sobre tu servicio?</h4>
        <p>Por favor comunícate con nosotros lo antes posible para poder brindarte el apoyo que necesitas</p>
    </div>

</div>